export default __webpack_public_path__ + "static/media/competitive-audit.f894d36e.png";